<div class="container my-5">
  <div class="row align-items-center mb-4">
    <div class="col d-flex align-items-center gap-3 flex-wrap">
      <h2 class="text-left h3-tipografia-govco mb-0 me-auto">Dashboard</h2>
      <button
        class="btn-govco outline-btn-govco me-2"
        (click)="downloadDiccionario()"
        aria-label="Descargar diccionario">
        {{ 'dashboard.descargar' | translate }}
        <i class="ms-2 fa fa-file-excel-o" aria-hidden="true"></i>
      </button>
      <button class="btn-govco outline-btn-govco" 
        (click)="downloadManual()"
        aria-label="Descargar manual">
        {{ 'dashboard.manual' | translate }}
        <i class="ms-2 fa fa-user-o" aria-hidden="true"></i>
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md-8">
      <app-actividad />
    </div>
    <div class="col-12 col-md-4">
      <app-ultimos-cambios />
    </div>
  </div>
  <app-ultimos-usuarios />
</div>
